const ROOT = 'SKILLS_';

const actions = {
  PROCESS_ACTION_REQUEST: `${ROOT}PROCESS_ACTION_REQUEST`,
  PROCESS_ACTION_SUCCESS: `${ROOT}PROCESS_ACTION_SUCCESS`,
  PROCESS_ACTION_ERROR: `${ROOT}PROCESS_ACTION_ERROR`,
  LOAD_ACTIVE_SKILL_REQUEST: `${ROOT}LOAD_ACTIVE_SKILL_REQUEST`,
  LOAD_ACTIVE_SKILL_SUCCESS: `${ROOT}LOAD_ACTIVE_SKILL_SUCCESS`,
  LOAD_ACTIVE_SKILL_ERROR: `${ROOT}LOAD_ACTIVE_SKILL_ERROR`,
  LOAD_PENDING_SKILL_REQUEST: `${ROOT}LOAD_PENDING_SKILL_REQUEST`,
  LOAD_PENDING_SKILL_SUCCESS: `${ROOT}LOAD_PENDING_SKILL_SUCCESS`,
  LOAD_PENDING_SKILL_ERROR: `${ROOT}LOAD_PENDING_SKILL_ERROR`,
  LOAD_DENIED_SKILL_REQUEST: `${ROOT}LOAD_DENIED_SKILL_REQUEST`,
  LOAD_DENIED_SKILL_SUCCESS: `${ROOT}LOAD_DENIED_SKILL_SUCCESS`,
  LOAD_DENIED_SKILL_ERROR: `${ROOT}LOAD_DENIED_SKILL_ERROR`,
} as const;

export default actions;
